(function patchDrawerSingleton() {
  function setup() {
    const Drawer = customElements.get('x-drawer');
    if (!Drawer || Drawer.prototype._ygSingletonPatched) return;

    Drawer.prototype._ygSingletonPatched = true;

    const originalShow = Drawer.prototype.show;
    Drawer.prototype.show = function (animate = true) {
      document.querySelectorAll('x-drawer[open]').forEach((drawer) => {
        if (drawer !== this) drawer.hide();
      });
      return originalShow.call(this, animate);
    };
  }

  if (customElements.get('x-drawer')) {
    setup();
  } else {
    customElements.whenDefined('x-drawer').then(setup);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const syncHeaderTopState = () => {
    const header = document.querySelector('.header');
    const header__wrapper = document.querySelector('.header__wrapper');


    if (!header) return;

    const { top } = header.getBoundingClientRect();
    const isAtTop = top <= 1;

    console.log("header:",header);
    console.log("header-top:",top)

    document.documentElement.classList.toggle(
      'header-is-top',
      isAtTop
    );
    
  };

  syncHeaderTopState();
  window.addEventListener('scroll', syncHeaderTopState, { passive: true });
  window.addEventListener('resize', syncHeaderTopState);
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const newImg = new Image();
          newImg.onload = () => {
            img.src = newImg.src;
            img.removeAttribute('data-src'); // 如果只需要加载一次
            img.removeAttribute('srcset');
            observer.unobserve(img); // 停止观察该元素
          };
          newImg.src = img.getAttribute('data-src');
        }
      });
    },
    {
      rootMargin: '50px' // 预加载距离视口 50px 的图片
    }
  );

  class YGImage extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg();
    }

    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img);
      });
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage);
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => {});
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML =
        $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (
        e.target.className == 'yg-popup-box-close' ||
        e.target.className == 'yg-popup-box'
      ) {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate =
        this.querySelector('template') ||
        this.querySelector('.yg-popup-template');

      if (!$popupTemplate) return;

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate: $popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass
          }
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGProductItem extends HTMLElement {
    static productsData = [];
    static orderId = null;
    static tradeInDiscountType = null; // 'free' | 'discount' | null
    static tradeInBonusProductIds = []; // Dynamically populated from freeProductData/discountProductData
    static _suppressProductDataUpdate = false; // 防止在清除 bonus 期间触发错误的价格计算
    static get observedAttributes() {
      return ['data-product-data'];
    }

    constructor() {
      super();
      this.onTradeInClick = this.onTradeInClick.bind(this);
    }
    connectedCallback() {
      this.options =
        this.querySelectorAll('.product_option') ||
        this.querySelectorAll('.yg-warranty-products__option');
      this.productItem = this;
      this.selectedOption =
        this.querySelector('.product_option.active') ||
        this.querySelector('.active');
      this.addProductData(this.getAttribute('data-product-data'));
      this.classList.contains('default') && this.updateProductData();

      // Trade In: delegated handler (survives innerHTML rerenders)
      this.addEventListener('click', this.onTradeInClick);

      // 延迟执行initSelectOption，确保DOM渲染完成
      setTimeout(() => {
        if (typeof this.initSelectOption === 'function') {
          this.initSelectOption();
        }
      }, 300);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onTradeInClick);
      this.removeProductData(this.getAttribute('data-product-data'));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-product-data' && oldValue !== newValue) {
        this.removeProductData(oldValue);
        this.addProductData(newValue);

        // 清除 bonus 期间不派发事件，由 selectOption 手动派发最终数据
        if (YGProductItem._suppressProductDataUpdate) {
          return;
        }

        document.dispatchEvent(
          new CustomEvent('product-data-updated', {
            detail: {
              productsData: YGProductItem.productsData
            },
            bubbles: true, // 允许事件冒泡
            cancelable: true // 允许事件被取消
          })
        );
      }
    }

    initSelectOption() {
      this.options.forEach((option, index) => {
        // Trade In option is not a selectable product option
        if (
          option.classList &&
          option.classList.contains('yg-trade-in-option')
        ) {
          return;
        }
        option.addEventListener('click', () =>
          this.selectOption(option, index)
        );
      });

      this.updateSelectOption();
    }

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
    }

    hideAllTradeInResults() {
      // Hide results within this element (if any)
      this.querySelectorAll('[data-trade-in-result]').forEach((node) => {
        node.style.display = 'none';
      });
      // Hide results in sibling container (yg-trade-in-result-container)
      const resultContainer = this.querySelector(
        '.yg-trade-in-result-container'
      );
      if (resultContainer) {
        resultContainer.classList.remove('active');
        resultContainer
          .querySelectorAll('[data-trade-in-result]')
          .forEach((node) => {
            node.style.display = 'none';
          });
      }
    }

    hideTradeInFormElements() {
      // this is the yg-product-item element
      const productItem = this;
      const resultContainer = productItem.querySelector(
        '.yg-trade-in-result-container'
      );
      resultContainer && resultContainer.classList.add('active');

      // Hide all .product_option elements
      const allOptions = productItem.querySelectorAll('.product_option');
      allOptions.forEach((option) => {
        option.style.display = 'none';
      });

      // Hide header and fields within yg-trade-in-option (sibling element)
      const tradeInOption = productItem.querySelector('.yg-trade-in-option');
      if (tradeInOption) {
        const header = tradeInOption.querySelector('.yg-trade-in-form-header');
        const fields = tradeInOption.querySelector('.yg-trade-in-form-fields');
        header && (header.style.display = 'none');
        fields && (fields.style.display = 'none');
      }
    }

    showTradeInFormElements() {
      // this is the yg-product-item element
      const productItem = this;
      const resultContainer = productItem.querySelector(
        '.yg-trade-in-result-container'
      );
      resultContainer && resultContainer.classList.remove('active');

      // Show all .product_option
      const allOptions = productItem.querySelectorAll('.product_option');
      allOptions.forEach((option) => {
        option.style.display = '';
      });

      // Restore header and fields display for yg-trade-in-option (sibling element)
      const tradeInOption = productItem.querySelector('.yg-trade-in-option');
      if (tradeInOption) {
        const header = tradeInOption.querySelector('.yg-trade-in-form-header');
        const fields = tradeInOption.querySelector('.yg-trade-in-form-fields');
        header && (header.style.display = '');
        fields && (fields.style.display = '');
      }
    }

    scrollToTradeInElements() {
      const productItem = this;
      const resultContainer = productItem.querySelector(
        '.yg-trade-in-result-container'
      );

      if (resultContainer) {
        resultContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }

    onTradeInClick(e) {
      const toggle = e.target.closest?.('[data-trade-in-toggle]');
      const submit = e.target.closest?.('[data-trade-in-submit]');
      const edit = e.target.closest?.('[data-trade-in-edit]');

      if (!toggle && !submit && !edit) return;

      const wrapper = this.querySelector('.yg-trade-in-form-wrapper');

      // Avoid triggering option selection click handlers
      e.preventDefault();
      e.stopPropagation();

      if (toggle) {
        wrapper.classList.toggle('yg-trade-in-form-expanded');
        this.deselectCurrentOption();

        return;
      }

      if (edit) {
        this.hideAllTradeInResults();
        // Show other product options when editing
        this.showTradeInFormElements();
        wrapper.classList.add('yg-trade-in-form-expanded');
        const orderIdInput = this.querySelector('[data-trade-in-order-id]');
        orderIdInput && orderIdInput.focus();
        return;
      }

      // submit
      const orderIdInput = this.querySelector('[data-trade-in-order-id]');
      const emailInput = this.querySelector('[data-trade-in-email]');
      const orderId = orderIdInput ? orderIdInput.value.trim() : '';
      const email = emailInput ? emailInput.value.trim() : '';

      if (!orderId || !email) {
        alert('Please enter both Order ID and Email');
        return;
      }
      if (!this.isValidEmail(email)) {
        alert('Please enter a valid email address');
        return;
      }

      submit.disabled = true;
      const originalText = submit.textContent;
      submit.textContent = 'Verifying...';

      // Call API to verify order
      fetch(
        `https://app.steigen.com.sg/steigen_app/api/customer/v1/upgrade/upgradable?email=${encodeURIComponent(email)}&order_number=${encodeURIComponent(orderId)}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.hideAllTradeInResults();

          // Check API response
          const tradeInOption = this.querySelector('.yg-trade-in-option');
          const freeProductData = tradeInOption?.dataset?.freeProduct
            ? JSON.parse(tradeInOption.dataset.freeProduct)
            : null;
          const discountProductData = tradeInOption?.dataset?.discountProduct
            ? JSON.parse(tradeInOption.dataset.discountProduct)
            : null;

          console.log('freeProductData==================>', freeProductData);
          console.log(
            'discountProductData==================>',
            discountProductData
          );
          if (data.result === 'success' && data.data === true) {
            // Verified success - show success result
            const success1 = this.querySelector(
              '[data-trade-in-result="success1"]'
            );
            success1 && (success1.style.display = 'flex');

            // Scroll to trade-in form elements
            this.scrollToTradeInElements();

            // Store orderId and discount type for checkout
            YGProductItem.orderId = orderId;
            YGProductItem.tradeInDiscountType = 'free';

            // Dynamically update trade-in bonus product IDs
            if (freeProductData?.id) {
              if (
                !YGProductItem.tradeInBonusProductIds.includes(
                  freeProductData.id
                )
              ) {
                YGProductItem.tradeInBonusProductIds.push(freeProductData.id);
              }
            }

            // 标记当前实例已完成 trade-in，用于后续判断是否需要清除状态
            this._hasTradeInResult = true;

            // 先移除旧的带有 Upgrade From Order 属性的产品（确保不会有重复的 trade-in 产品）
            YGProductItem.productsData = YGProductItem.productsData.filter(
              (p) => !p.properties || !p.properties['Upgrade From Order']
            );

            // Add trade-in bonus product to YGBuyNow.productsData for Buy Now
            // User will need to click Buy Now to checkout
            const tradeInBonusProduct = {
              id: freeProductData?.id || 48355597156611,
              price: freeProductData?.price || 0,
              quantity: 1,
              properties: {
                'Upgrade From Order': orderId
              }
            };
            YGProductItem.productsData.push(tradeInBonusProduct);

            // Deselect current product_option when adding bonus product
            this.deselectCurrentOption();

            // Trigger price update
            document.dispatchEvent(
              new CustomEvent('product-data-updated', {
                detail: {
                  productsData: YGProductItem.productsData
                },
                bubbles: true,
                cancelable: true
              })
            );
          } else if (data.result === 'success' && data.data === false) {
            // Verified but no discount - show success2
            const success2 = this.querySelector(
              '[data-trade-in-result="success2"]'
            );
            success2 && (success2.style.display = 'flex');

            // Scroll to trade-in form elements
            this.scrollToTradeInElements();

            // Store orderId and discount type for checkout
            YGProductItem.orderId = orderId;
            YGProductItem.tradeInDiscountType = 'discount';

            // Dynamically update trade-in bonus product IDs
            if (discountProductData?.id) {
              if (
                !YGProductItem.tradeInBonusProductIds.includes(
                  discountProductData.id
                )
              ) {
                YGProductItem.tradeInBonusProductIds.push(
                  discountProductData.id
                );
              }
            }

            // 标记当前实例已完成 trade-in，用于后续判断是否需要清除状态
            this._hasTradeInResult = true;

            // 先移除旧的带有 Upgrade From Order 属性的产品（确保不会有重复的 trade-in 产品）
            YGProductItem.productsData = YGProductItem.productsData.filter(
              (p) => !p.properties || !p.properties['Upgrade From Order']
            );

            // Add different bonus product to YGBuyNow.productsData for Buy Now
            // User will need to click Buy Now to checkout
            const discountPrice = parseFloat(discountProductData?.price) || 0;
            const tradeInBonusProduct = {
              id: discountProductData?.id || 48355597123843,
              price: (discountPrice - 0.01).toFixed(2),
              quantity: 1,
              properties: {
                'Upgrade From Order': orderId
              }
            };
            YGProductItem.productsData.push(tradeInBonusProduct);

            // Deselect current product_option when adding bonus product
            this.deselectCurrentOption();
            console.log(
              'YGBuyNow.productsData222==================>',
              YGProductItem.productsData
            );

            // Trigger price update
            document.dispatchEvent(
              new CustomEvent('product-data-updated', {
                detail: {
                  productsData: YGProductItem.productsData
                },
                bubbles: true,
                cancelable: true
              })
            );
          } else {
            // API error or validation error
            const errorResult = this.querySelector(
              '[data-trade-in-result="error"]'
            );
            errorResult && (errorResult.style.display = 'flex');

            // Scroll to trade-in form elements
            this.scrollToTradeInElements();
          }

          wrapper.classList.remove('yg-trade-in-form-expanded');
          submit.disabled = false;
          submit.textContent = originalText || 'Submit';

          // Hide other product options and form elements when result is shown
          this.hideTradeInFormElements();
        })
        .catch((error) => {
          console.error('Trade In API error:', error);
          // Show error state on network failure
          this.hideAllTradeInResults();
          const errorResult = this.querySelector(
            '[data-trade-in-result="error"]'
          );
          errorResult && (errorResult.style.display = 'flex');

          wrapper.classList.remove('yg-trade-in-form-expanded');
          submit.disabled = false;
          submit.textContent = originalText || 'Submit';

          this.hideTradeInFormElements();
        });
    }
    addProductData(newValue) {
      if (newValue) {
        const newData = JSON.parse(newValue);
        if (!newData.id) return;
        console.log('newData: ', newData);

        // 检查是否已存在完全相同的数据
        const exists = YGProductItem.productsData.some((existingData) =>
          this.isDataEqual(existingData, newData)
        );

        // 如果不存在，则添加
        if (!exists) {
          YGProductItem.productsData.push(newData);
        }
      }
    }

    removeProductData(oldValue) {
      if (oldValue) {
        const oldData = JSON.parse(oldValue);

        // 检查是否存在完全相同的数据
        const exists = YGProductItem.productsData.some((existingData) =>
          this.isDataEqual(existingData, oldData)
        );

        // 如果存在，则删除
        if (exists) {
          YGProductItem.productsData = YGProductItem.productsData.filter(
            (existingData) => !this.isDataEqual(existingData, oldData)
          );
        }
      }
    }

    // 深度比较两个数据对象是否完全相同
    isDataEqual(data1, data2) {
      // 检查基本类型
      if (data1 === data2) return true;
      if (data1 == null || data2 == null) return data1 === data2;
      if (typeof data1 !== typeof data2) return false;

      // 检查对象类型
      if (typeof data1 === 'object') {
        const keys1 = Object.keys(data1);
        const keys2 = Object.keys(data2);

        // 检查键的数量
        if (keys1.length !== keys2.length) return false;

        // 检查每个键值对
        for (let key of keys1) {
          if (!keys2.includes(key)) return false;
          if (!this.isDataEqual(data1[key], data2[key])) return false;
        }

        return true;
      }

      // 基本类型直接比较
      return data1 === data2;
    }

    updateProductData() {
      let active = this.querySelector('.active');
      if (!active) {
        return;
      }
      this.setAttribute(
        'data-product-data',
        JSON.stringify({
          title: active.dataset.productTitle,
          buyLabel: active.dataset.buyLabel,
          id: active.dataset.productId,
          price: active.dataset.productPrice,
          compare_price: active.dataset.productComparePrice,
          inventory: parseInt(active.dataset.productInventory) || 0,
          productType: active.dataset.productType || ''
        })
      );
    }

    deselectCurrentOption() {
      // 移除所有 product_option 的选中状态
      this.options.forEach((opt) => {
        opt.classList.remove('active');
        opt.removeAttribute('selected');
      });
      // 清空选中状态
      this.selectedOption = null;
      // 清除 data-product-data 属性
      this.removeAttribute('data-product-data');
    }

    selectOption(option, index) {
      // 移除所有选中状态
      this.options.forEach((opt) => {
        opt.classList.remove('active');
      });

      // 添加选中状态到当前选项
      option.classList.add('active');
      this.selectedOption = option;

      // 检查新选的 option 是否是 trade-in 选项
      const newOptionIsTradeIn =
        option.classList && option.classList.contains('yg-trade-in-option');

      // 当前实例是否包含 trade-in 选项元素（意味着这个实例支持 trade-in）
      const hasTradeInOption =
        this.querySelector('.yg-trade-in-option') !== null;
      console.log('hasTradeInOption==================>', hasTradeInOption);

      // 只要当前实例支持 trade-in，且点击的不是 trade-in 选项，就清除 trade-in 状态
      // 这样：1. 点击其他 YGProductItem 的 product_option 不影响有 trade-in 的实例
      //      2. 点击 trade-in 实例的其他 product_option 会清除 trade-in 状态
      if (hasTradeInOption && !newOptionIsTradeIn) {
        // 移除 trade-in bonus products 和含有 Upgrade From Order: 属性的产品 从 productsData
        YGProductItem.productsData = YGProductItem.productsData.filter(
          (product) => {
            // 移除 tradeInBonusProductIds 列表中的产品
            if (
              YGProductItem.tradeInBonusProductIds.includes(String(product.id))
            ) {
              return false;
            }
            // 移除含有 Upgrade From Order: 属性的产品（如以旧换新升级产品）
            if (
              product.properties &&
              product.properties['Upgrade From Order']
            ) {
              return false;
            }
            return true;
          }
        );
        // 清除 trade-in 状态
        YGProductItem.orderId = null;
        YGProductItem.tradeInDiscountType = null;
        // 清空动态 bonus product IDs
        YGProductItem.tradeInBonusProductIds = [];
        // 重置实例标记
        this._hasTradeInResult = false;
        // 隐藏 trade-in 结果
        this.hideAllTradeInResults();
        // 重新派发 product-data-updated，确保监听器拿到正确的（清除 bonus 后的）数据
        document.dispatchEvent(
          new CustomEvent('product-data-updated', {
            detail: { productsData: YGProductItem.productsData },
            bubbles: true,
            cancelable: true
          })
        );
      }

      this.updateSelectOption();

      // 同步更新 YGBuyNow.productsData，确保购买时使用最新的产品数据
      // YGBuyNow 继承自 YGProductItem，共享 productsData 静态属性
      // 但需要确保当前选中的产品被正确添加到数组中
      if (this.classList.contains('default')) {
        this.updateProductData();
      }

      // 移除 trade-in 表单展开状态
      const wrapper = this.querySelector('.yg-trade-in-form-wrapper');
      wrapper && wrapper.classList.remove('yg-trade-in-form-expanded');
    }

    updateSelectOption() {
      if (!this.selectedOption) {
        return;
      }

      // 检查是否需要清空产品数据（不付费选项或不确定选项）
      if (
        this.selectedOption.classList.contains('yg-im-no-sure-item') ||
        this.selectedOption.classList.contains('yg-date-dont-need-to-pay')
      ) {
        // 清空产品数据，表示没有选择具体的安装方式变体或不需要付费
        this.productItem.setAttribute('data-product-data', '');
        return;
      }

      this.productItem.setAttribute(
        'data-product-data',
        JSON.stringify({
          buyLabel: this.selectedOption.dataset.buyLabel,
          id: this.selectedOption.dataset.productId,
          price: this.selectedOption.dataset.productPrice,
          compare_price: this.selectedOption.dataset.productComparePrice,
          inventory:
            parseInt(this.selectedOption.dataset.productInventory) || 0,
          productType: this.selectedOption.dataset.productType || ''
        })
      );
    }
  }

  if (!window.customElements.get('yg-product-item')) {
    window.customElements.define('yg-product-item', YGProductItem);
  }

  class YGBuyNow extends YGProductItem {
    constructor() {
      super();
      this.buyNowClick = this.buyNowClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.buyNowClick);
    }
    // 方法1: 简单实现
    toTitleCase(str) {
      return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    }
    disconnectedCallback() {}
    buyNowClick() {
      console.log('YGBuyNow.productsData: ', YGBuyNow.productsData);

      // 校验 Unit - 如果填写了 postal code，unit 就是必填项
      const appointment = window.ygAppointmentInfo?.appointment_details?.[0];
      const postCode = appointment?.post_code;
      const unit = appointment?.unit;

      if (postCode && (!unit || unit.trim() === '')) {
        const unitInput = document.getElementById('yg-unit-number-input');
        const errorMessage = document.getElementById('yg-ia-error-message');

        if (unitInput) {
          unitInput.classList.add('has-error');
          unitInput.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          unitInput.focus();
        }

        if (errorMessage) {
          errorMessage.textContent = 'Please enter your unit number';
          errorMessage.classList.add('show');
        }

        return; // 阻止后续操作
      }

      // 查找主产品数据（productType 元字段为 'Product' 的是主产品）
      const mainProduct = YGBuyNow.productsData.find(
        (product) => product.productType === 'Product'
      );
      // 检查主产品库存是否 <= 0
      const isStockout =
        mainProduct && mainProduct.inventory !== undefined
          ? mainProduct.inventory <= 0
          : false;

      // 将 isStockout 同步到 window.ygPreOrder
      if (window.ygPreOrder) {
        window.ygPreOrder.isStockout = isStockout;
      }

      // 构建预售相关的订单属性
      const preOrderAttributes = {};
      if (window.ygPreOrder?.isPreOrder) {
        preOrderAttributes.is_pre_order = 'true';
        if (window.ygPreOrder.preOrderDate) {
          preOrderAttributes.pre_order_date = window.ygPreOrder.preOrderDate;
        }
        if (isStockout) {
          preOrderAttributes.is_stockout = 'true';
        }
      } else if (isStockout) {
        // 非预售情况下，如果缺货也添加 is_stockout
        preOrderAttributes.is_stockout = 'true';
      }

      let productData = {
        items: [
          {
            id: 48362468245763,
            quantity: 1
          }
        ],
        attributes: {
          ...(window.getYgBuyNowAttributesData
            ? window.getYgBuyNowAttributesData()
            : window.ygBuyNowAttributesData),
          appointment_info: JSON.stringify(window.ygAppointmentInfo),
          ...preOrderAttributes,
          // 添加订单属性（如Upgrade From Order）
          ...(YGProductItem.orderId && {
            'Upgrade From Order': YGProductItem.orderId
          })
        }
      };
      YGBuyNow.productsData.forEach((product) => {
        if (product.id) {
          // Only add 'Upgrade From Order' property to the specific trade-in bonus products
          const itemProperties = {};
          if (
            YGProductItem.tradeInBonusProductIds.includes(product.id) &&
            productData.attributes &&
            productData.attributes['Upgrade From Order']
          ) {
            itemProperties['Upgrade From Order'] =
              productData.attributes['Upgrade From Order'];
          }
          // 如果产品本身有properties，也合并进去
          if (product.properties) {
            Object.assign(itemProperties, product.properties);
          }

          productData.items.push({
            id: product.id,
            quantity: product.quantity || 1,
            ...(Object.keys(itemProperties).length > 0 && {
              properties: itemProperties
            })
          });
        }
      });

      if (productData.items.length <= 0) return;

      this.classList.add('active');

      // 仅需要通过传入参数获取到checkoutUrl
      const storefrontApiKey = '887a739f9d5fb8c72d4aefe13378111e';
      const apiVersion = '2026-01';
      const shopDomain = window.Shopify?.shop || window.location.hostname;
      const graphqlUrl = `https://${shopDomain}/api/${apiVersion}/graphql.json`;

      const toGid = (variantId) => {
        const value = String(variantId || '');
        return value.indexOf('gid://') === 0
          ? value
          : `gid://shopify/ProductVariant/${value}`;
      };

      const lines = productData.items.map((item) => {
        const lineItem = {
          merchandiseId: toGid(item.id),
          quantity: parseInt(item.quantity) || 1
        };
        if (item.properties && Object.keys(item.properties).length > 0) {
          lineItem.attributes = Object.entries(item.properties).map(
            ([key, value]) => ({
              key,
              value: String(value)
            })
          );
        }
        return lineItem;
      });

      const cartAttributes = Object.entries(productData.attributes || {}).map(
        ([key, value]) => ({
          key,
          value: typeof value === 'string' ? value : JSON.stringify(value)
        })
      );

      // 调用 Storefront API 获取 checkoutUrl
      fetch(graphqlUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontApiKey
        },
        body: JSON.stringify({
          query: `mutation YGBuyNowCreateCart($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }`,
          variables: {
            input: {
              lines,
              attributes: cartAttributes
            }
          }
        })
      })
        .then((response) => response.json())
        .then((json) => {
          const topLevelErrors = Array.isArray(json.errors)
            ? json.errors.map((error) => error.message).filter(Boolean)
            : [];
          const userErrors = json.data?.cartCreate?.userErrors || [];
          const errorMessages = topLevelErrors.concat(
            userErrors.map((error) => error.message).filter(Boolean)
          );

          if (errorMessages.length) {
            throw new Error(errorMessages.join(', '));
          }

          let checkoutUrl = json.data?.cartCreate?.cart?.checkoutUrl;
          if (!checkoutUrl) {
            throw new Error('Unable to start checkout.');
          }

          // 获取postal code和地址，用于checkout页信息回调
          const appointment =
            window.ygAppointmentInfo?.appointment_details?.[0];
          const postCode = appointment?.post_code;
          const streetName = appointment?.street_name;
          const buildingNumber = appointment?.building_number;
          const buildingName = appointment?.building_name;
          const unit = appointment?.unit;

          const params = [];
          if (postCode) {
            params.push(
              'checkout[shipping_address][zip]=' + encodeURIComponent(postCode)
            );
          }

          const address1Parts = [];
          if (buildingNumber) address1Parts.push(buildingNumber);
          if (streetName) address1Parts.push(streetName);
          if (address1Parts.length > 0) {
            const address1 = address1Parts.join(' ');
            params.push(
              'checkout[shipping_address][address1]=' +
                encodeURIComponent(address1)
            );
          }

          let address2 = '';
          if (buildingName && unit) {
            address2 = `${buildingName}, #${unit}`;
          } else if (buildingName) {
            address2 = buildingName;
          } else if (unit) {
            address2 = `#${unit}`;
          }
          if (address2) {
            params.push(
              'checkout[shipping_address][address2]=' +
                encodeURIComponent(address2)
            );
          }

          if (params.length > 0) {
            const paramsString = params.join('&');
            checkoutUrl +=
              (checkoutUrl.includes('?') ? '&' : '?') + paramsString;
          }

          console.log(checkoutUrl, 'checkoutUrl');

          this.classList.remove('active');
          window.location.href = checkoutUrl;
        })
        .catch((error) => {
          this.classList.remove('active');
          console.error('Storefront API checkout error:', error);
        });

      return;

      // 先清空购物车

      // fetch('/cart/clear.js', {
      //   method: 'POST'
      // })
      //   .then((response) => response.json())
      //   .then((data) => {
      //     console.log('购物车已清空:', data);

      //     // 然后添加商品到购物车
      //     return fetch('/cart/add.js', {
      //       method: 'POST',
      //       headers: {
      //         'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify(productData)
      //     });
      //   })
      //   .then((response) => response.json())
      //   .then((data) => {
      //     console.log('商品已添加到购物车:', data);
      //     // 获取postal code和地址，用于checkout页信息回调
      //     const appointment =
      //       window.ygAppointmentInfo?.appointment_details?.[0];
      //     const postCode = appointment?.post_code;
      //     const streetName = appointment?.street_name;
      //     const buildingNumber = appointment?.building_number;
      //     const buildingName = appointment?.building_name;
      //     const unit = appointment?.unit;

      //     const params = [];
      //     if (postCode) {
      //       params.push(
      //         'checkout[shipping_address][zip]=' + encodeURIComponent(postCode)
      //       );
      //     }

      //     const address1Parts = [];
      //     if (buildingNumber) address1Parts.push(buildingNumber);
      //     if (streetName) address1Parts.push(streetName);
      //     if (address1Parts.length > 0) {
      //       const address1 = address1Parts.join(' ');
      //       params.push(
      //         'checkout[shipping_address][address1]=' +
      //           encodeURIComponent(address1)
      //       );
      //     }

      //     let address2 = '';
      //     if (buildingName && unit) {
      //       // buildingName和unit都有
      //       address2 = `${buildingName}, #${unit}`;
      //     } else if (buildingName) {
      //       // 只有buildingName
      //       address2 = buildingName;
      //     } else if (unit) {
      //       // 只有unit
      //       address2 = `#${unit}`;
      //     }
      //     if (address2) {
      //       params.push(
      //         'checkout[shipping_address][address2]=' +
      //           encodeURIComponent(address2)
      //       );
      //     }

      //     const paramsString = params.join('&');

      //     // 可以在这里添加成功后的处理逻辑，比如跳转到购物车页面
      //     this.classList.remove('active');
      //     console.log(
      //       'window.ygBuyNowAttributesData==================>',
      //       window.ygBuyNowAttributesData
      //     );
      //     console.log(
      //       'window.ygAppointmentInfo==================>',
      //       window.ygAppointmentInfo
      //     );
      //     console.log(
      //       'checkout==================>',
      //       '/checkout?' + paramsString
      //     );

      //     window.location.href = '/checkout?' + paramsString;
      //   })
      //   .catch((error) => {
      //     this.classList.remove('active');
      //     console.error('操作失败:', error);
      //   });
    }
  }
  if (!window.customElements.get('yg-buy-now')) {
    window.customElements.define('yg-buy-now', YGBuyNow);
  }

  class YGStickyBuy extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.visiblePrices = new Set();
    }

    connectedCallback() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.visiblePrices.add(entry.target);
            } else {
              this.visiblePrices.delete(entry.target);
            }
          });

          // 切换 class
          if (this.visiblePrices.size > 0) {
            this.classList.add('is-hidden'); // 有价格可见 → 隐藏自己
          } else {
            this.classList.remove('is-hidden'); // 全部不可见 → 显示自己
          }
        },
        {
          root: null,
          threshold: 0.1
        }
      );
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.visiblePrices.clear();
    }
  }

  if (!window.customElements.get('yg-sticky-buy')) {
    window.customElements.define('yg-sticky-buy', YGStickyBuy);
  }

  class YGPrice extends YGProductItem {
    constructor() {
      super();
      this.stickyBuys = document.querySelectorAll('yg-sticky-buy');
      this.productDataUpdated = this.productDataUpdated.bind(this);
    }

    connectedCallback() {
      this.stickyObserverCallback('add');
      document.addEventListener(
        'product-data-updated',
        this.productDataUpdated
      );
    }

    disconnectedCallback() {
      this.stickyObserverCallback('remove');
      document.removeEventListener(
        'product-data-updated',
        this.productDataUpdated
      );
    }

    productDataUpdated(event) {
      let productsData = event.detail.productsData;
      let currency = this.getAttribute('data-currency');
      let discountType = YGProductItem.tradeInDiscountType;
      console.log('productsData: ', productsData);

      // Helper: 判断某个 product 是否参与折扣计算
      let isDiscountable = (product) => {
        // 主产品或 bonus 产品参与折扣
        if (product.productType === 'Product') return true;
        if (product.properties && product.properties['Upgrade From Order'])
          return true;
        return false;
      };

      let priceTotal = productsData.reduce((total, product) => {
        let price =
          parseFloat(String(product.price || '0').replace(',', '')) || 0;
        // 主产品、bonus 产品参与折扣，其他产品（warranty等）不打折
        if (isDiscountable(product)) {
          if (discountType === 'free') {
            price = 0;
          } else if (discountType === 'discount') {
            price = price * 0.8;
          }
        }
        return total + price;
      }, 0);
      let comparePriceTotal = productsData.reduce((total, product) => {
        let comparePrice =
          parseFloat(String(product.compare_price || '0').replace(',', '')) ||
          0;
        return total + comparePrice;
      }, 0);

      this.querySelector('.price').innerHTML =
        currency +
        priceTotal.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

      if (comparePriceTotal <= priceTotal) {
        this.querySelector('.compare-price').innerHTML = '';
        return;
      }
      this.querySelector('.compare-price').innerHTML =
        currency +
        comparePriceTotal.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
    }

    stickyObserverCallback(operation) {
      this.stickyBuys?.forEach((sticky) => {
        if (sticky.observer && !this.closest('yg-sticky-buy')) {
          if (operation === 'add') {
            sticky.observer.observe(this);
            sticky.visiblePrices.clear();
          }
          if (operation === 'remove') {
            sticky.observer.unobserve(this);
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-price')) {
    window.customElements.define('yg-price', YGPrice);
  }

  class YGProductCurrentParameter extends YGProductItem {
    constructor() {
      super();
      this.productDataUpdated = this.productDataUpdated.bind(this);
    }

    connectedCallback() {
      document.addEventListener(
        'product-data-updated',
        this.productDataUpdated
      );
    }

    disconnectedCallback() {
      document.removeEventListener(
        'product-data-updated',
        this.productDataUpdated
      );
    }

    productDataUpdated(event) {
      let productsData = event.detail.productsData;

      if (this.getAttribute('data-buy-label')) {
        // 定义顺序映射
        const buyLabelOrder = {
          Size: 0,
          Drying: 1,
          Colour: 2,
          'Trade-in': 3,
          Warranty: 4
        };

        // 先获取所有 buyLabel 对象数组
        let buyLabelArr = productsData
          .map((product) => {
            if (product.buyLabel) {
              // 去除首尾空格后返回
              return String(product.buyLabel).trim();
            }
            return;
          })
          .filter(Boolean)
          .join('')
          .split('##')
          .map((s) => s.trim())
          .filter(Boolean)
          .map((buyLabel) => {
            const buyLabelValue = buyLabel.split('||');
            if (buyLabelValue.length === 2) {
              return {
                title: buyLabelValue[0].trim(),
                value: buyLabelValue[1].trim()
              };
            }
            return null;
          })
          .filter(Boolean);

        // 排序
        buyLabelArr.sort((a, b) => {
          // 默认大排序（未知的title要排在最后）
          const orderA = buyLabelOrder.hasOwnProperty(a.title)
            ? buyLabelOrder[a.title]
            : 999;
          const orderB = buyLabelOrder.hasOwnProperty(b.title)
            ? buyLabelOrder[b.title]
            : 999;
          return orderA - orderB;
        });

        let buyLabelHTML = buyLabelArr
          .map((buyLabelItem) => {
            return `<div class='yg-buy-label'><span class="buy-label-title">${buyLabelItem.title}</span><span class="buy-label-value">${buyLabelItem.value}</span></div>`;
          })
          .join('');

        this.innerHTML = buyLabelHTML;

        return;
      }

      let optionValue = productsData
        .map((product) => {
          if (product.title) {
            return product.title;
          }
          return;
        })
        .filter(Boolean);
      if (!optionValue[0]) return;

      this.innerHTML = optionValue;

      let option2Value = optionValue[0]?.split('|')[1];
      let option2Titles = document.querySelectorAll('.option2Title');
      // option2Titles遍历将content内容修改为option2Value
      option2Titles.forEach(function (titleEl) {
        titleEl.textContent = option2Value;
      });
    }
  }
  if (!window.customElements.get('yg-product-current-parameter')) {
    window.customElements.define(
      'yg-product-current-parameter',
      YGProductCurrentParameter
    );
  }

  // class YGWarrantySelector extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.options = this.querySelectorAll('.yg-warranty-products__option');
  //     this.productItem = this.querySelector('yg-product-item');
  //     this.selectedOption = this.querySelector(
  //       '.yg-warranty-products__option.active'
  //     );
  //   }

  //   connectedCallback() {
  //     this.init();
  //   }

  //   disconnectedCallback() {
  //     this.options.forEach((option) => {
  //       option.removeEventListener('click', () =>
  //         this.selectOption(option, index)
  //       );
  //     });
  //   }

  //   init() {
  //     this.options.forEach((option, index) => {
  //       option.addEventListener('click', () =>
  //         this.selectOption(option, index)
  //       );
  //     });

  //     this.updateSelectOption();
  //   }

  //   selectOption(option, index) {
  //     // 移除所有选中状态
  //     this.options.forEach((opt) => {
  //       opt.classList.remove('active');
  //     });

  //     // 添加选中状态到当前选项
  //     option.classList.add('active');
  //     this.selectedOption = option;

  //     this.updateSelectOption();
  //   }

  //   updateSelectOption() {
  //     if (!this.selectedOption) {
  //       return;
  //     }

  //     // 检查是否需要清空产品数据（不付费选项或不确定选项）
  //     if (
  //       this.selectedOption.classList.contains('yg-im-no-sure-item') ||
  //       this.selectedOption.classList.contains('yg-date-dont-need-to-pay')
  //     ) {
  //       // 清空产品数据，表示没有选择具体的安装方式变体或不需要付费
  //       this.productItem.setAttribute('data-product-data', '');
  //       return;
  //     }

  //     this.productItem.setAttribute(
  //       'data-product-data',
  //       JSON.stringify({
  //         id: this.selectedOption.dataset.productId,
  //         price: this.selectedOption.dataset.productPrice,
  //         compare_price: this.selectedOption.dataset.productComparePrice
  //       })
  //     );
  //   }
  // }

  // if (!window.customElements.get('yg-warranty-selector')) {
  //   window.customElements.define('yg-warranty-selector', YGWarrantySelector);
  // }

  class YGProductGallery extends HTMLElement {
    constructor() {
      super();
      this.imageSwiper = null;
      this.index = 0;
      this.videoBox = this.querySelector('.yg-custom-video');
      this.videoButton = this.querySelector('.yg-custom-video-thumb');
      this.imageSwiperBox = this.querySelector('.swiper');
      this.imageList = this.querySelectorAll(
        '.yg-product-images .yg-image-item'
      );
      this.videoClick = this.videoClick.bind(this);
      this.imageClick = this.imageClick.bind(this);
      this.imageMobileButton = this.querySelector('.yg-product-images-mobile');
      this.videoMobileButton = this.querySelector('.yg-custom-video-mobile');
    }

    connectedCallback() {
      this.initSwiper();
      this.videoButton?.addEventListener('click', this.videoClick);
      this.imageList?.forEach((item, i) => {
        item.addEventListener('click', () => this.imageClick(i));
      });
      this.imageMobileButton?.addEventListener('click', () =>
        this.imageClick()
      );
      this.videoMobileButton?.addEventListener('click', () =>
        this.videoClick()
      );
    }

    disconnectedCallback() {
      this.videoButton?.removeEventListener('click', () => this.videoClick());
      this.imageList.forEach((item) => {
        item.removeEventListener('click', () => this.imageClick(i));
      });
    }

    initSwiper() {
      this.imageSwiper = new Swiper(this.imageSwiperBox, {
        // Swiper 配置项
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          slideChange: () => {
            this.imageClick(this.imageSwiper.activeIndex);
          }
        }
      });
    }

    imageClick(i) {
      i = i || this.index;

      let $imageNumber = this.querySelector('.yg-image-number');
      this.imageList.forEach((item, index) => {
        if (index === i) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      if ($imageNumber) {
        let imageCount = this.imageList.length - 1;
        let currentCount = i < 6 ? imageCount - 5 : imageCount - i;
        $imageNumber.innerHTML = currentCount <= 0 ? '' : `+${currentCount}`;
      }

      if (i != -1) {
        if (this.imageMobileButton) {
          this.imageMobileButton.classList.add('active');
        }
        if (this.videoMobileButton) {
          this.videoMobileButton.classList.remove('active');
        }
        this.showElement(this.imageSwiperBox, 'image');
        this.imageSwiper.slideTo(i);
        this.index = i;
      }
    }

    videoClick() {
      if (this.imageMobileButton) {
        this.imageMobileButton.classList.remove('active');
      }
      if (this.videoMobileButton) {
        this.videoMobileButton.classList.add('active');
      }
      this.showElement(this.videoBox, 'video');
    }

    showElement(element, type) {
      if (!element.classList.contains('hide')) {
        return;
      }

      this.videoBox.classList.add('hide');
      this.imageSwiperBox.classList.add('hide');

      if (type == 'image') {
        this.videoBox.querySelector('video').pause();
        this.videoButton.querySelector('video').play();
        this.videoBox.querySelector('video').currentTime = 0;
      }

      if (type == 'video') {
        this.videoBox.querySelector('video').play();
        this.videoButton.querySelector('video').pause();
        this.videoButton.querySelector('video').currentTime = 0;

        this.imageClick('-1');
      }

      element.classList.remove('hide');
    }
  }
  if (!window.customElements.get('yg-product-gallery')) {
    window.customElements.define('yg-product-gallery', YGProductGallery);
  }
  class YGProductContent extends HTMLElement {
    constructor() {
      super();
      this.contentTypes = this.querySelectorAll('.yg-product-content-type');
      this.contentList = this.querySelectorAll('.yg-product-content-list-item');
      this.measurementTabs = this.querySelectorAll('.yg-measurement-tab');
      this.measurementPcContents = this.querySelectorAll(
        '.yg-measurement-pc-content'
      );
      this.measurementCards = this.querySelectorAll('.yg-measurement-card');
      this.learnMoreLinks = this.querySelectorAll('.yg-measurement-learn-more');
      this.toggleImageButtons = this.querySelectorAll(
        '.yg-measurement-toggle-images'
      );
      this.observer = null;
    }

    connectedCallback() {
      this.contentTypes.forEach((contentType, i) => {
        contentType.addEventListener('click', () => this.typeSwitch(i, true));
      });
      this.measurementTabs.forEach((tab, i) => {
        tab.addEventListener('click', (e) => {
          e.stopPropagation();
          this.measurementSwitch(i);
        });
      });
      this.learnMoreLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
      this.toggleImageButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleImages(button);
        });
      });
      this.initIntersectionObserver();
    }

    disconnectedCallback() {
      this.contentTypes.forEach((contentType) => {
        contentType.removeEventListener('click', () => this.typeSwitch(i));
      });
      this.measurementTabs.forEach((tab) => {
        tab.removeEventListener('click', () => this.measurementSwitch(i));
      });
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    typeSwitch(index, isClick = false) {
      this.contentTypes.forEach((contentType, i) => {
        contentType.classList.remove('active');
        if (i === index) {
          contentType.classList.add('active');

          if (this.contentList && this.contentList[i] && isClick) {
            if (this.observer) {
              // 如果是点击触发，先取消当前元素的IntersectionObserver监控
              this.observer.unobserve(this.contentList[i]);
            }

            this.contentList[i].scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });

            if (this.observer) {
              // 等待scrollIntoView动画完成后重新监控
              setTimeout(() => {
                this.observer.observe(this.contentList[i]);
              }, 500); // 根据smooth动画的持续时间调整延迟
            }
          }
        }
      });
    }

    measurementSwitch(index) {
      const isMobile = window.innerWidth <= 1000;
      const clickedTab = this.measurementTabs[index];
      const isCurrentlyActive =
        clickedTab && clickedTab.classList.contains('active');

      // 切换 tab 状态
      this.measurementTabs.forEach((tab, i) => {
        if (i === index) {
          if (isMobile && isCurrentlyActive) {
            // 移动端：点击已激活的 tab 时收缩
            tab.classList.remove('active');
            // 同时重置图片展开状态
            const card = tab.nextElementSibling;
            if (card && card.classList.contains('yg-measurement-card')) {
              this.resetCardImages(card);
            }
          } else {
            tab.classList.add('active');
          }
        } else {
          tab.classList.remove('active');
          // 重置其他卡片的图片展开状态
          if (isMobile) {
            const card = tab.nextElementSibling;
            if (card && card.classList.contains('yg-measurement-card')) {
              this.resetCardImages(card);
            }
          }
        }
      });

      // 切换 PC 端内容显示
      this.measurementPcContents.forEach((content, i) => {
        content.classList.remove('active');
        if (i === index && !isCurrentlyActive) {
          content.classList.add('active');
        }
      });
    }

    resetCardImages(card) {
      const imagesContainer = card.querySelector('.yg-measurement-card-images');
      const toggleButton = card.querySelector('.yg-measurement-toggle-images');

      if (imagesContainer) {
        imagesContainer.classList.remove('expanded');
      }

      if (toggleButton) {
        toggleButton.setAttribute('data-expanded', 'false');
        const textMore = toggleButton.querySelector('.yg-toggle-text-more');
        const textLess = toggleButton.querySelector('.yg-toggle-text-less');
        if (textMore) textMore.style.display = '';
        if (textLess) textLess.style.display = 'none';
      }
    }

    toggleImages(button) {
      const card = button.closest('.yg-measurement-card');
      if (!card) return;

      const imagesContainer = card.querySelector('.yg-measurement-card-images');
      const textMore = button.querySelector('.yg-toggle-text-more');
      const textLess = button.querySelector('.yg-toggle-text-less');
      const isExpanded = button.getAttribute('data-expanded') === 'true';

      if (isExpanded) {
        // 收起
        imagesContainer.classList.remove('expanded');
        button.setAttribute('data-expanded', 'false');
        textMore.style.display = '';
        textLess.style.display = 'none';

        // 滚动到相应的 tab
        const cardIndex = card.getAttribute('data-index');
        const correspondingTab = this.querySelector(
          `.yg-measurement-tab[data-index="${cardIndex}"]`
        );
        if (correspondingTab) {
          // 等待动画完成后滚动
          setTimeout(() => {
            const headerHeight = parseInt(
              getComputedStyle(document.documentElement).getPropertyValue(
                '--header-height'
              ) || '0'
            );
            const offset = headerHeight + 20;
            const tabTop =
              correspondingTab.getBoundingClientRect().top +
              window.scrollY -
              offset;
            window.scrollTo({
              top: tabTop,
              behavior: 'smooth'
            });
          }, 100);
        }
      } else {
        // 展开
        imagesContainer.classList.add('expanded');
        button.setAttribute('data-expanded', 'true');
        textMore.style.display = 'none';
        textLess.style.display = '';
      }
    }

    initIntersectionObserver() {
      if (!this.contentList.length) return;

      const options = {
        root: null, // 使用视口作为根
        rootMargin: '-20% 0px -20% 0px', // 当元素进入视口中心区域时触发
        threshold: 0.5 // 当50%的元素可见时触发
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 找到当前进入视口的元素在 contentList 中的索引
            const index = Array.from(this.contentList).indexOf(entry.target);
            if (index !== -1) {
              this.typeSwitch(index);
            }
          }
        });
      }, options);

      // 开始观察所有 contentList 元素
      this.contentList.forEach((item) => {
        this.observer.observe(item);
      });
    }
  }
  if (!window.customElements.get('yg-product-content')) {
    window.customElements.define('yg-product-content', YGProductContent);
  }
  class YGSwiper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.getAllAttributes();
      this.initSwiper();
    }

    get getCurrentSlidesPerView() {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints'])
        .map(Number)
        .sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes() {
      let booleanAttrs = [
        'loop',
        'pagination',
        'navigation',
        'scrollbar',
        'centered-slides'
      ];
      let jsonAttrs = ['breakpoints'];
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay']
          ? {
              delay: this['autoplay'],
              stopOnLastSlide: false,
              disableOnInteraction: false,
              pauseOnMouseEnter: false
            }
          : false,
        pagination: this['pagination']
          ? {
              el: '.swiper-pagination',
              clickable: true
            }
          : false,
        navigation: this['navigation']
          ? {
              nextEl: this['navigation-class']
                ? `.${this['navigation-class']}-next`
                : '.swiper-button-next',
              prevEl: this['navigation-class']
                ? `.${this['navigation-class']}-prev`
                : '.swiper-button-prev'
            }
          : false,
        scrollbar: this['scrollbar']
          ? {
              el: '.swiper-scrollbar',
              hide: true
            }
          : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        on: {
          init: (e) => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 2;
              }

              if (sliderLength <= num) {
                for (
                  let index = 1;
                  index < Math.ceil(num / sliderLength);
                  index++
                ) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  });
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll(
                    '.swiper-pagination-bullet'
                  );
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  });
                }, 250);
              }
            }
          }
        }
      });
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper);
  }
});
